import angular from 'angular';
import template from './panel.html';
import fbtemplate from './builder/preview.html';
import PanelComponent from './panel.component';

const panelConfig = /* @ngInject */ (
	/** @type {any} */ KformComponentsProvider,
	/** @type {any} */ FORM_OPTIONS,
) => {
	KformComponentsProvider.register('panel', {
		title: 'Panel',
		template,
		group: 'layout',
		children:   false,
		selectable: true,
		settings: new PanelComponent(),
		fbtemplate,
		icon: 'fa fa-list-alt',
		onEdit: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.themes = FORM_OPTIONS.themes;
			if (!$scope.component.breadcrumb) {
				$scope.component.breadcrumb = 'default';
			}
			$scope.breadcrumbs = [
				{
					name: 'default',
					title: 'Yes',
				},
				{
					name: 'none',
					title: 'No',
				},
			];
		},
		views: [
			{
				name: 'Display',
				template: 'kform/components/panel/display.html',
			},
			{
				name: 'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name: 'API',
				template: 'kform/components/common/api.html',
			},
			{
				name: 'Conditional',
				template: 'kform/components/panel/conditional.html',
			},
		],
		noDndOverlay: true,
		confirmRemove: true,
	});
};

export default angular.module('app').config(panelConfig);
